import thorchainRuneWhiteLogo from './logos/thorchain-rune-white-logo.svg'
import thorchainRuneBlackLogo from './logos/thorchain-rune-black-logo.svg'
import thorchainRuneIcon from './logos/thorchain-rune-icon.svg'
//import mainLogoWhite from './logos/ThorCharts_Logo&Text_White.svg'
import mainLogoBlack from './logos/ThorChartsLogoBlack.svg'
import mainLogoWhite from './logos/ThorChartsLogoWhite.svg'
export const thorchainRuneIconSVG = thorchainRuneIcon
export const mainLogoWhiteSVG = mainLogoWhite
export const mainLogoBlackSVG = mainLogoBlack
